import $ from 'jquery';
import { merge } from "lodash";

const defaults = {
  selectors: {
    front: "[data-flip-card-front]",
    back: "[data-flip-card-back]",
    showFront: "[data-flip-card-show-front]",
    showBack: "[data-flip-card-show-back]",
    overlayWrapper: "body",
  },
  classes: {
    zIndex103: "z-index-103",
    zIndex104: "z-index-110",
    showFront: "flip-card-show-front",
    showBack: "flip-card-show-back",
    showFrontIn: "flip-card-show-front-in",
    showBackIn: "flip-card-show-back-in",
    overlay: "flip-card__overlay",
    overlayShown: "flip-card__overlay--shown",
    overlayShownIn: "flip-card__overlay--shown-in",
    overlayShownOut: "flip-card__overlay--shown-out",
  },
};

class FlipCard {
  constructor(flipCard, options) {
    this.flipCard = flipCard;
    this.options = merge({}, defaults, options);
  }

  run() {
    this.init();
    this.bindEvents();
  }

  init() {
    this.showFrontButton = this.flipCard.querySelector(this.options.selectors.showFront);
    this.showBackButton = this.flipCard.querySelector(this.options.selectors.showBack);

    this.showFront();
    this.initOverlay();
  }

  initOverlay() {
    if (!this.overlayExists()) {
      this.createOverlay();
    } else {
      this.overlay = this.getOverlay();
    }
  }

  overlayExists() {
    return this.getOverlay() !== null;
  }

  getOverlay() {
    return document.querySelector(this.options.classes.overlay);
  }

  createOverlay() {
    this.overlay = document.createElement("div");
    this.overlay.classList.add(this.options.classes.overlay);

    document.querySelector(this.options.selectors.overlayWrapper).append(this.overlay);
  }

  bindEvents() {
    if (this.showFrontButton) {
      this.showFrontButton.addEventListener("click", this.showFrontHandler.bind(this));
    }

    if (this.showBackButton) {
      this.showBackButton.addEventListener("click", this.showBackHandler.bind(this));
    }
  }

  showFrontHandler(e) {
    
    var target = $( event.target );
    if ( target.is( "a" ) || target.is( "video" )  ) {
      return
    }else{
      e.preventDefault();
      this.hideOverlay();
      this.showFront();
    }

  }

  showBackHandler(e) {
    e.preventDefault();
    this.showOverlay();
    this.showBack();

  }

  showFront() {
    this.flipCard.classList.add(this.options.classes.showFrontIn);
    this.flipCard.classList.add(this.options.classes.showFront);
    this.flipCard.classList.remove(this.options.classes.zIndex104);
    this.flipCard.parentNode.classList.remove(this.options.classes.zIndex104);
    this.flipCard.classList.remove(this.options.classes.showBack);
    this.flipCard.querySelector('.flip-card-back').classList.remove('back-container');
    this.flipCard.querySelector('.flip-card-front').classList.remove('z-minus-1');
    

    setTimeout(() => {
      this.flipCard.classList.remove(this.options.classes.showFrontIn);
    }, 1000);
  }

  showBack() {
    this.flipCard.classList.add(this.options.classes.showBackIn);
    this.flipCard.classList.add(this.options.classes.showBack);
    this.flipCard.classList.remove(this.options.classes.showFront);
    this.flipCard.classList.add(this.options.classes.zIndex104);
    this.flipCard.parentNode.classList.add(this.options.classes.zIndex104);
    this.flipCard.querySelector('.flip-card-back').classList.add('back-container');
    this.flipCard.querySelector('.flip-card-front').classList.add('z-minus-1');
    setTimeout(() => {
      this.flipCard.classList.remove(this.options.classes.showBackIn);
    }, 1000);
  }

  removeInClasses() {
    this.flipCard.classList.remove(this.options.classes.showBackIn);
    this.flipCard.classList.remove(this.options.classes.showFrontIn);
  }

  showOverlay() {
    this.overlay.classList.add(this.options.classes.overlayShownIn);
    this.overlay.classList.add(this.options.classes.overlayShown);

    this.overlay.addEventListener('click', () => {
      this.flipCard.classList.add(this.options.classes.showFrontIn);
      this.flipCard.classList.add(this.options.classes.showFront);
      this.flipCard.classList.remove(this.options.classes.showBack);
      setTimeout(() => {
        this.flipCard.classList.remove(this.options.classes.showFrontIn);
      }, 1000);
      this.overlay.classList.add(this.options.classes.overlayShownOut);
      this.overlay.classList.remove(this.options.classes.overlayShown);
      setTimeout(() => {
        this.overlay.classList.remove(this.options.classes.overlayShownOut);
      }, 1000);

      this.flipCard.classList.remove(this.options.classes.zIndex104);
      this.flipCard.parentNode.classList.remove(this.options.classes.zIndex104);
      
     
    })

    setTimeout(() => {
      this.overlay.classList.remove(this.options.classes.overlayShownIn);
    }, 1000);
  }

  hideOverlay() {
    this.overlay.classList.add(this.options.classes.overlayShownOut);
    this.overlay.classList.remove(this.options.classes.overlayShown);

    setTimeout(() => {
      this.overlay.classList.remove(this.options.classes.overlayShownOut);
    }, 1000);
  }
}

document.addEventListener("DOMContentLoaded", init);

function init() {
  const options = {
    selectors: {
      overlayWrapper: ".wrapper",
    },
  };
  const flipCards = [...document.querySelectorAll("[data-flip-card]")];

  flipCards.map((el) => {
    new FlipCard(el, options).run();
  });
}